// «Сесс дууслаа» (401) дараа дахин нэвтэрсний дараа хэрэглэгчийг буцаах зам.
// Нэг түлхүүр; нэг удаа уншигдаад устна. sessionStorage хаагдсан/хориглосон үед чимээгүй алгасна.
const KEY = "auth-admin.returnPath";
const SKIP = ["/login", "/businesses", "/verify", "/forgot", "/auth/gate-hub"];

function basePath(): string {
  return String((window as any).__BASE_PATH__ || "").replace(/\/$/, "");
}

/** Одоогийн router замыг (basename-гүй) хадгална. Нүүр хуудас ба нэвтрэх урсгалын замыг хадгалахгүй. */
export function rememberReturnPath(): void {
  try {
    const base = basePath();
    let path = window.location.pathname;
    if (base && path.startsWith(base)) path = path.slice(base.length);
    path = `${path || "/"}${window.location.search}`;
    const bare = path.split("?")[0];
    if (bare === "/" || SKIP.some((p) => bare === p || bare.startsWith(`${p}/`))) return;
    sessionStorage.setItem(KEY, path);
  } catch {
    /* storage unavailable */
  }
}

/** Хадгалсан замыг нэг удаа уншиж устгана; байхгүй эсвэл найдваргүй бол null. */
export function consumeReturnPath(): string | null {
  try {
    const path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return path && path.startsWith("/") && !path.startsWith("//") ? path : null;
  } catch {
    return null;
  }
}
